import React from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { ConventionLogoSquare } from "./ConventionLogo";
import { formatConventionDate, formatLocation } from "@seabrookstudios/pitch2table-core";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").CalendarEvent[]} props.conventions - List of conventions to display
 * @param {import("@seabrookstudios/pitch2table-core").ConventionId[]} props.selectedConventions - Currently selected convention IDs
 * @param {function(import("@seabrookstudios/pitch2table-core").ConventionId): void} props.onToggleConvention - Callback when a convention is toggled
 */
export const FilterableConventionsList = ({ conventions, selectedConventions, onToggleConvention }) => {
  return (
    <>
      <List>
        {conventions.map((convention) => (
          <ListItemButton key={convention.id} onClick={() => onToggleConvention(convention.id)}>
            <ListItemAvatar>
              <ConventionLogoSquare convention={convention} />
            </ListItemAvatar>
            <ListItemText
              primary={convention.name}
              secondary={`${formatConventionDate(convention)} • ${formatLocation(convention)}`}
            />
            <ListItemIcon>
              {selectedConventions.includes(convention.id) && <CheckCircle color="success" />}
            </ListItemIcon>
          </ListItemButton>
        ))}
      </List>
      {conventions.length === 0 && (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <p>No conventions found.</p>
        </div>
      )}
    </>
  );
};
